import styled from '@emotion/styled';

interface ContainerProps {
  panelIsOpen: boolean;
}

export const Container = styled.div<ContainerProps>`
  flex: 1;
  position: relative;

  pointer-events: ${({panelIsOpen}) => (panelIsOpen ? 'all' : 'none')};
`;
